import { graphql } from '@/generated/gql';

export const RESET_CONVERSATION_MUTATION = graphql(/* GraphQL */ `
  mutation ResetConversation($data: SvbrgChatSessionInput!) {
    sevenbridges {
      chatSession {
        reset(data: $data) {
          id
          conversationSettings {
            id
            createdAt
            updatedAt
            quickActions {
              id
              prompt
              isConversationStarter
              translations {
                id
                language
                text
                variant
              }
            }
            tools {
              id
              isEnabled
            }
          }
          conversationMessages {
            id
            role
            content
            parts
            createdAt
          }
        }
      }
    }
  }
`);
